(() => {
  'use strict';
  if (window.innMobileMenuV1) { window.innMobileMenuV1.init(); return; }
  const mobile = matchMedia('(max-width: 991px)');
  const instances = new Map();
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('bs-BA').trim();
  function setup(source) {
    if (instances.has(source) || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    const template = source.querySelector('template[data-inn-menu-template]');
    const host = source.closest('header-drawer');
    const details = host?.querySelector(':scope > details');
    const trigger = details?.querySelector(':scope > summary');
    if (!template || !trigger) return;
    const controller = new AbortController();
    const originalControls = trigger.getAttribute('aria-controls');
    const listen = (element, name, handler, extra = {}) => element.addEventListener(name, handler, { signal: controller.signal, ...extra });
    let dialog = null;
    let savedBody = null;
    let scrollPosition = 0;
    let viewport = null;
    function restore() {
      if (savedBody) {
        for (const [property, value, priority] of savedBody) {
          if (value) document.body.style.setProperty(property, value, priority);
          else document.body.style.removeProperty(property);
        }
        savedBody = null;
        const behavior = document.documentElement.style.getPropertyValue('scroll-behavior');
        const priority = document.documentElement.style.getPropertyPriority('scroll-behavior');
        document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
        window.scrollTo(0, scrollPosition);
        if (behavior) document.documentElement.style.setProperty('scroll-behavior', behavior, priority);
        else document.documentElement.style.removeProperty('scroll-behavior');
      }
      if (viewport) { viewport.abort(); viewport = null; }
      trigger.setAttribute('aria-expanded', 'false');
      if (mobile.matches && trigger.getClientRects().length) trigger.focus({ preventScroll: true });
    }
    function close() {
      if (dialog?.open) dialog.close();
      restore();
    }
    function selectTab(tab, focus = false) {
      const group = tab.closest('[data-imm-group]');
      group.querySelectorAll('[role="tab"]').forEach(other => {
        const selected = tab === other;
        other.setAttribute('aria-selected', String(selected));
        other.tabIndex = selected ? 0 : -1;
        const panel = dialog.querySelector('#' + other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }
    function toggleGroup(button) {
      const open = button.getAttribute('aria-expanded') !== 'true';
      const scroller = dialog.querySelector('.imm-scroll');
      dialog.querySelectorAll('.imm-toggle').forEach(other => {
        const expanded = other === button && open;
        other.setAttribute('aria-expanded', String(expanded));
        const panel = dialog.querySelector('#' + other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !expanded;
      });
      if (open) {
        const top = button.getBoundingClientRect().top;
        const visibleTop = scroller.getBoundingClientRect().top;
        if (top < visibleTop) scroller.scrollTop += top - visibleTop - 8;
      }
    }
    function build() {
      if (dialog) return;
      dialog = template.content.querySelector('dialog').cloneNode(true);
      document.body.append(dialog);
      listen(dialog.querySelector('.imm-close'), 'click', close);
      listen(dialog, 'click', event => {
        const button = event.target.closest('button');
        if (button?.matches('.imm-toggle')) toggleGroup(button);
        else if (button?.matches('[role="tab"]')) selectTab(button);
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }
      });
      listen(dialog, 'keydown', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        selectTab(tabs[index], true);
      });
      listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
      listen(dialog, 'close', () => { if (!dialog.open) restore(); });
      const brandSearch = dialog.querySelector('[data-imm-brand-search]');
      if (brandSearch) listen(brandSearch, 'input', () => {
        const query = normalize(brandSearch.value);
        let shown = 0;
        dialog.querySelectorAll('[data-imm-brand]').forEach(link => {
          link.hidden = !normalize(link.textContent).includes(query);
          if (!link.hidden) shown++;
        });
        dialog.querySelector('.imm-no-brands').hidden = shown > 0;
      });
      listen(dialog.querySelector('.imm-search'), 'submit', event => {
        const input = dialog.querySelector('#imm-search-input');
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.focus(); }
      });
    }
    function sizeToViewport() {
      if (!dialog?.open) return;
      const visual = window.visualViewport;
      dialog.style.height = (visual?.height || innerHeight) + 'px';
      dialog.style.top = (visual?.offsetTop || 0) + 'px';
    }
    function open(event) {
      if (!mobile.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (dialog?.open) { close(); return; }
      try {
        build();
        scrollPosition = window.scrollY;
        const properties = ['position', 'top', 'left', 'right', 'width', 'overflow'];
        savedBody = properties.map(property => [property, document.body.style.getPropertyValue(property), document.body.style.getPropertyPriority(property)]);
        document.body.style.setProperty('position', 'fixed');
        document.body.style.setProperty('top', -scrollPosition + 'px');
        document.body.style.setProperty('left', '0');
        document.body.style.setProperty('right', '0');
        document.body.style.setProperty('width', '100%');
        document.body.style.setProperty('overflow', 'hidden');
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        trigger.setAttribute('aria-controls', dialog.id);
        dialog.querySelector('.imm-close').focus({ preventScroll: true });
        sizeToViewport();
        viewport = new AbortController();
        window.visualViewport?.addEventListener('resize', sizeToViewport, { signal: viewport.signal });
        window.visualViewport?.addEventListener('scroll', sizeToViewport, { signal: viewport.signal });
      } catch (_) {
        restore();
        controller.abort();
        dialog?.remove();
        if (originalControls) trigger.setAttribute('aria-controls', originalControls);
        else trigger.removeAttribute('aria-controls');
        instances.delete(source);
        trigger.click();
      }
    }
    listen(trigger, 'click', open, { capture: true });
    const instance = { close, destroy() { close(); controller.abort(); dialog?.remove(); if (originalControls) trigger.setAttribute('aria-controls', originalControls); else trigger.removeAttribute('aria-controls'); instances.delete(source); } };
    instances.set(source, instance);
  }
  function init() {
    if (!mobile.matches) return;
    const stylesheet = document.querySelector('link[data-inn-menu-style]');
    if (!stylesheet?.sheet) return;
    document.querySelectorAll('[data-inn-menu-source]').forEach(source => {
      if (getComputedStyle(source).getPropertyValue('--imm-ready').trim() === '1') setup(source);
    });
  }
  window.innMobileMenuV1 = { init };
  mobile.addEventListener('change', () => {
    if (mobile.matches) init();
    else instances.forEach(instance => instance.close());
  });
  document.querySelectorAll('link[data-inn-menu-style]').forEach(link => link.addEventListener('load', init, { once: true }));
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, source) => { if (event.target.contains(source)) instance.destroy(); });
  });
  window.addEventListener('pagehide', () => instances.forEach(instance => instance.close()));
  window.addEventListener('pageshow', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();